var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.66664 666.65403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c6c6c6;\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #7c7c7c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "top__bubble",
    className: "cls-1",
    d: "M733.33331,208.33333v170c0,42.33332-14,78-39,102.66666C669.66665,506,634,520,591.66664,520v60.33332c0,22.66667-25.33334,36.33333-44,23.66669l-32.33335-21.33337A120.97,120.97,0,0,0,519.66665,549V413.3333c0-68-45.33335-113.33331-113.33335-113.33331H179.99966c-4.66666,0-8.99966.334-13.333.66732v-92.334c0-85,56.66666-141.66667,141.66666-141.66667H591.66664C676.66662,66.66666,733.33331,123.33333,733.33331,208.33333Z",
    transform: "translate(-66.66666 -66.66666)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bottom__bubble",
    className: "cls-2",
    d: "M519.66665,413.3333V549a120.97,120.97,0,0,1-4.33334,33.66667c-12.33332,49-53,79.66671-109,79.66671H315.66666L215,729.33328c-15,10.33338-35.00033-.66662-35.00033-18.66665V662.33334c-34,0-62.333-11.33334-81.99966-31C78,611.33332,66.66666,583,66.66666,549V413.3333c0-63.33331,39.33334-106.99932,100-112.666C171,300.334,175.333,300,179.99966,300H406.3333C474.3333,300,519.66665,345.33331,519.66665,413.3333Z",
    transform: "translate(-66.66666 -66.66666)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubbles);
export default __webpack_public_path__ + "static/media/message-bubbles.eddedb6f.svg";
export { ForwardRef as ReactComponent };